import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'
import { CircleCheckIcon } from '@ui/icons/CircleCheck.icon'
import { FlagIcon } from '@ui/icons/flags'

import { CountryPreferenceStrippedDto } from '@model/CountryDto'

import { inMemorySort } from '@hooks/useSortBy'

import { Box } from '@shared/components/Box'

interface Props {
  title?: string
  info?: string
  options: CountryPreferenceStrippedDto[]
  initialValue?: string
  onChangeOption: (country: CountryPreferenceStrippedDto) => void
}

export const PhoneCodeModal: BaseModalType<Props> = (props) => {
  const { t } = useTranslation()
  const { options, info, initialValue, close, onChangeOption } = props
  const { title = t('Sign up.Phone Code') } = props
  const [search, setSearch] = useState('')
  const [countryList, setCountryList] = useState(options)

  const handleSetSearch = (value: string) => {
    setSearch(value)
    setCountryList(
      options.filter(
        (x) =>
          x.country.name.toLowerCase().startsWith(value.toLowerCase()) ||
          (x.phoneCode || '').startsWith(`+${value}`)
      )
    )
  }

  const handleSelect = (country: CountryPreferenceStrippedDto) => {
    onChangeOption(country)
    close()
  }

  return (
    <Modal>
      <Modal.Header
        search={{
          onChange: handleSetSearch,
          value: search,
        }}
      >
        {title}
      </Modal.Header>
      <Modal.Body>
        {info && <Modal.Body.Text>{info}</Modal.Body.Text>}
        {inMemorySort(countryList, 'country.name').map((country) => (
          <Box
            fullWidth
            flex
            align='center'
            gap='x16'
            py='x4'
            key={country.country.id}
            onClick={() => handleSelect(country)}
          >
            <Box style={{ minWidth: 24 }} flex align='center' justify='center' radius='round'>
              <FlagIcon countryCode={country.country.id} />
            </Box>

            <Box style={{ flex: '1 1 auto' }}>
              <Modal.Body.Text>
                {country.phoneCode} {country.country.name}
                {country.country.nativeName ? (
                  <span className='has-text-grey ml-1'>({country.country.nativeName})</span>
                ) : null}
              </Modal.Body.Text>
            </Box>

            {country.country.id === initialValue && (
              <Box flex justify='end'>
                <CircleCheckIcon />
              </Box>
            )}
          </Box>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
